import React, { useState } from 'react';

//@ts-ignore
import '../../styles/sentiment-gauge.scss';

import { LinearProgress, Typography } from '@mui/joy';
import { useAuth } from '../../context/authContext';
import InfoTooltipComponent from '../InfoTooltipComponent';

const networking = require('../../Networking/API');

function SentimentBreakdownComponent(app: any) {
    const { token } = useAuth();

    const [reviews, setReviews] = useState(null) as any[];

    var badPercentage = 0;
    var goodPercentage = 0;
    var neutralPercentage = 0;
    var badReviews = 0;
    var goodReviews = 0;
    var neutralReviews = 0;

    if (!reviews) {
        getData();
    }

    function getData() {
        networking.reviewsFor(app.app.id, token).then((reviews: any) => {
            setReviews(reviews);
        }).catch((error: Error) => {
        });
    }

    if (reviews) {
        badReviews = reviews.filter((d: any) => d.sentiment === 'bad').length;
        goodReviews = reviews.filter((d: any) => d.sentiment === 'good').length;
        neutralReviews = reviews.filter((d: any) => d.sentiment === 'neutral').length;

        const total = reviews.length;

        badPercentage = Math.round((badReviews / total) * 100);
        goodPercentage = Math.round((goodReviews / total) * 100);
        neutralPercentage = Math.round((neutralReviews / total) * 100);
    }

    return (
        <div>
            <div className='text-center'>
                <Typography
                    color='neutral'
                    fontWeight={600}
                    level='body-xs'>
                    {"Sentiment breakdown".toUpperCase()}
                    <InfoTooltipComponent
                        message={"Sentiment breakdown is calculated based on the sentiment of the reviews received for the app. It shows the percentage of good, neutral, and bad reviews."}
                        size={'sm'}
                        variant={'plain'}
                        color={'primary'} />
                </Typography>
            </div>
            <div className='p-5'>
                <div className='row my-auto mb-3'>
                    <div className='col p-0 my-auto'>
                        <LinearProgress determinate value={goodPercentage} color="success" />
                        <div className='row my-auto mt-2'>
                            <div className="col text-left">
                                <Typography
                                    color='neutral'
                                    fontWeight={800}
                                    sx={{
                                        fontSize: 10
                                    }}>
                                    Good
                                </Typography>
                            </div>
                            <div className="col-auto text-left">
                                <Typography
                                    color='neutral'
                                    fontWeight={800}
                                    sx={{
                                        fontSize: 10
                                    }}>
                                    {goodReviews}
                                    <Typography
                                        color='neutral'
                                        fontWeight={400}
                                        sx={{
                                            fontSize: 10
                                        }}>
                                        ({goodPercentage.toFixed(1)}%)
                                    </Typography>
                                </Typography>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row my-auto mb-3'>
                    <div className='col p-0 my-auto'>
                        <LinearProgress determinate value={neutralPercentage} color="warning" />
                        <div className='row my-auto mt-2'>
                            <div className="col text-left">
                                <Typography
                                    color='neutral'
                                    fontWeight={800}
                                    sx={{
                                        fontSize: 10
                                    }}>
                                    Neutral
                                </Typography>
                            </div>
                            <div className="col-auto text-left">
                                <Typography
                                    color='neutral'
                                    fontWeight={800}
                                    sx={{
                                        fontSize: 10
                                    }}>
                                    {neutralReviews}
                                    <Typography
                                        color='neutral'
                                        fontWeight={400}
                                        sx={{
                                            fontSize: 10
                                        }}>
                                        ({neutralPercentage.toFixed(1)}%)
                                    </Typography>
                                </Typography>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row my-auto'>
                    <div className='col p-0 my-auto'>
                        <LinearProgress determinate value={badPercentage} color="danger" />
                        <div className='row my-auto mt-2'>
                            <div className="col text-left">
                                <Typography
                                    color='neutral'
                                    fontWeight={800}
                                    sx={{
                                        fontSize: 10
                                    }}>
                                    Bad
                                </Typography>
                            </div>
                            <div className="col-auto text-left">
                                <Typography
                                    color='neutral'
                                    fontWeight={800}
                                    sx={{
                                        fontSize: 10
                                    }}>
                                    {badReviews}
                                    <Typography
                                        color='neutral'
                                        fontWeight={400}
                                        sx={{
                                            fontSize: 10
                                        }}>
                                        ({badPercentage.toFixed(1)}%)
                                    </Typography>
                                </Typography>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SentimentBreakdownComponent;